import { useUser } from '@/services/api/user'
import { Role } from '@/services/api/user/types'

const useAccess = () => {
  const { user, role } = useUser()

  return {
    super_admin: role === Role.SuperAdmin,
    admin: role === Role.Admin,
    teacher: role === Role.Teacher,
    parent: role === Role.Parent,
    support: role === Role.Support,
  }
}

export default useAccess
